import { connect } from 'react-redux';
import { IAppState } from '../../../models/reduxState';
import { initializeModalityStateOnGetHelp, setAuthInfoForTeams, updateDraftRequest } from '../../contactUs/reduxUpdater/actions/modalitySectionActions';
import { setContactSearchedQueryText } from '../../contactUs/reduxUpdater/actions/sharedStateActions';
import { dispatchGetEmeraldConfig, dispatchEmeraldSupportConfig, dispatchTeamsAsyncCallback, dispatchGetEmeraldConfigSuccess } from '../../contactUs/reduxUpdater/dispatchers/appDispatchers';
import { dispatchGetInfoForClientTokenRetrieval, dispatchUserInfoFetch, dispatchFetchAvailableModalitiesV2, dispatchAlchemyFetch } from '../../contactUs/reduxUpdater/dispatchers/contactUsDispatchers';
import { setWindowsUpdateAvailableForSA, setEndOfLifeMessageForSA, setEndOfServiceMessageForWin10SA, setDisplayNamespace, setInitializationComplete, setNavBarSettings, setTheme, updateUITabViewInfo, setMarket } from '../appActions';
import { AppInitializer } from '../presentationalComponents/appInitializer';
import { contactSearchedQuerySelector, getThemeSelector, isCMCRequestCreationDeeplinkSelector, isGetHelpSelector } from '../selectors/contactUsSelector';

const mapStateToProps = (state: IAppState, _ownProps: any) => {
  return {
    theme: getThemeSelector(state),
    environment: state.GlobalState.environment,
    sourceApp: state.GlobalState.sourceApp,
    initializationComplete: state.GlobalState.initializationComplete,
    socDataGrabComplete: state.GlobalState.socDataGrabComplete,
    globalState: state.GlobalState,
    sessionData: state.GlobalState.sessionData,
    hasThirdPartyCookiesEnabled: state.ContactState.ModalitySectionState.hasThirdPartyCookiesEnabled,
    queryParameterDictionary: state.GlobalState.queryParams,
    isGetHelp: isGetHelpSelector(state),
    isWindowsCopilotRequestCreationDeeplink: state.ContactState.SharedState.isWindowsCopilotRequestCreationDeeplink,
    isCMCRequestCreationDeeplink: isCMCRequestCreationDeeplinkSelector(state),
    contactSearchedQuery: contactSearchedQuerySelector(state),
  };
};

const mapDispatchToProps = {
  dispatchGetEmeraldConfig,
  dispatchEmeraldSupportConfig,
  dispatchUserInfoFetch,
  dispatchGetInfoForClientTokenRetrieval,
  setTheme,
  setDisplayNamespace,
  setInitializationComplete,
  setNavBarSettings,
  dispatchTeamsAsyncCallback,
  dispatchGetEmeraldConfigSuccess,
  updateDraftRequest,
  setContactSearchedQueryText,
  initializeModalityStateOnGetHelp,
  setAuthInfoForTeams,
  updateUITabViewInfo,
  setMarket,
  dispatchFetchAvailableModalitiesV2,
  setWindowsUpdateAvailableForSA,
  dispatchAlchemyFetch,
  setEndOfLifeMessageForSA,
  setEndOfServiceMessageForWin10SA,
};

export const AppInitializerContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AppInitializer);
